module.exports = __webpack_public_path__ + "img/gmxz-01.e8dda658.png";